import { getSettingValueAndAssign, getSettingValueWithoutAssignment } from "@faire/help-center-utils/settings/getSetting";
import { BRAND_SELF_SERVE_ORDERS_PAYMENTS_TREE_EXPANSION_240429 } from "@faire/web-api/indigofair/settings/BRAND_SELF_SERVE_ORDERS_PAYMENTS_TREE_EXPANSION_240429";
export function getSettingBrandSelfServeOrdersPayments() {
  return getSettingValueAndAssign(BRAND_SELF_SERVE_ORDERS_PAYMENTS_TREE_EXPANSION_240429, false);
}
export function getSettingBrandSelfServeOrdersPaymentsWithoutAssignments() {
  return getSettingValueWithoutAssignment(BRAND_SELF_SERVE_ORDERS_PAYMENTS_TREE_EXPANSION_240429, false);
}